module.exports = __webpack_public_path__ + "img/lab.6791e9f5.png";